import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { FaUserEdit } from 'react-icons/fa';

const s = {
  section: {
    border: '1px solid #d6d9de',
    borderRadius: 6,
    padding: '0.45rem',
    marginBottom: '0.4rem',
    background: '#f8fafc',
  },
  inlineField: { display: 'flex', alignItems: 'center', gap: 4 },
  inlineLabel: {
    minWidth: 66,
    marginBottom: 0,
    fontSize: '0.8rem',
    color: '#1f2937',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  codeCompact: { width: 78, flex: '0 0 78px' },
  rightGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
  },
  rightTag: {
    marginBottom: 0,
    fontSize: '0.78rem',
    color: '#1d4ed8',
    whiteSpace: 'nowrap',
    minWidth: 58,
    textAlign: 'right',
  },
  compact: { minHeight: 30, padding: '0.12rem 0.45rem', fontSize: '0.84rem' },
  codeField: {
    backgroundColor: '#d9f7ff',
    fontWeight: 700,
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
  },
  medField: {
    backgroundColor: '#fff78a',
    fontWeight: 700,
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
  },
  ativField: {
    backgroundColor: '#0b2b83',
    color: '#fff',
    fontWeight: 700,
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
  },
  statusField: {
    backgroundColor: '#fff200',
    color: '#1f2937',
    fontWeight: 700,
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
  },
  auditField: {
    backgroundColor: '#75beff',
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
    flex: 1,
  },
  celularField: {
    backgroundColor: '#abfca8',
    minHeight: 30,
    padding: '0.12rem 0.45rem',
    fontSize: '0.84rem',
    flex: 1,
  },
};

const AUDIT_COLUMNS = [
  { label: 'Nova Agenda', field: 'novaAgenda' },
  { label: 'Marcou', field: 'marcou' },
  { label: 'Faltou/Atendim/Chamou', field: 'faltouAtendeu' },
  { label: 'Atendido', field: 'atendido' },
  { label: 'Celular', field: 'celular', style: s.celularField },
];

export function FormAgendaFields({ hookData, register, agendaContext }) {
  const {
    codPacInput,
    codMedInput,
    medicoNome,
    convenioCodigo,
    procedimentoCodigo,
    horarioInt,
    pacienteSelecionado,
    convenioInputRef,
    procedimentoInputRef,
    observacaoInputRef,
    horarioInputRef,
    procedimentos,
    isLoadingProcedimentos,
    convenios,
    isLoadingConvenios,
    errors,
    hasCatalogosError,
    selectedDataAgenda,
    audit,

    situacaoAgenda,
    evolucao,
    openPacienteModal,
    handleChangeCodPac,
    handleChangeCodConvenio,
    handleChangeCodProcedimento,
    handleChangeHorario,

    handleAdvanceOnEnter,
    handleHorarioKeyDown,
    handleAtividadeKeyDown,

    apiError,
    setApiError,
  } = hookData;

  const { ref: obsRef, ...obsField } = register('observacao');
  const nomePaciente = String(pacienteSelecionado?.NOMEPAC || '').trim();
  const nomeExcedeAgenda = nomePaciente.length > 50;
  const alertaOk = typeof apiError === 'object' && apiError?.valido === true;
  const alertaTexto =
    typeof apiError === 'string' ? apiError : apiError?.aviso || apiError?.message || '';

  return (
    <div style={s.section}>
      {hasCatalogosError && (
        <Alert variant="danger" className="mb-2">
          Não foi possível carregar procedimentos e convênios. O agendamento foi bloqueado para
          evitar envio de códigos inválidos.
        </Alert>
      )}

      {/* Linha 1 — Paciente + OBS + Atividade */}
      <Row className="gx-2 gy-1 align-items-start mb-1">
        <Col xs={12} md={5}>
          <div style={s.inlineField}>
            <span style={s.inlineLabel}>Paciente:</span>
            <Form.Control
              size="sm"
              disabled={!agendaContext}
              value={codPacInput}
              onChange={handleChangeCodPac}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  openPacienteModal();
                }
              }}
              style={{ ...s.codeField, ...s.codeCompact }}
            />
            <Button
              variant="success"
              disabled={!agendaContext}
              size="sm"
              onClick={openPacienteModal}
              style={{ minWidth: 30 }}
            >
              <FaUserEdit className="m-0" />
            </Button>
            <Form.Control
              size="sm"
              disabled
              value={pacienteSelecionado?.NOMEPAC || ''}
              placeholder="Paciente"
              style={{ ...s.compact, flex: 1 }}
            />
          </div>
          {(errors.paciente || errors.pacienteBusca) && (
            <div className="invalid-feedback d-block">
              {errors.paciente?.message || errors.pacienteBusca?.message}
            </div>
          )}
          {nomeExcedeAgenda && (
            <div className="text-muted" style={{ fontSize: '0.75rem' }}>
              O nome tem mais de 50 caracteres e não entra na coluna da agenda. O cadastro do
              paciente permanece completo.
            </div>
          )}
        </Col>
        <Col xs={12} md={7}>
          <div style={s.rightGroup}>
            <span style={s.rightTag}>OBS:</span>
            <Form.Control
              as="textarea"
              rows={1}
              disabled={!agendaContext}
              size="sm"
              {...obsField}
              ref={(el) => {
                obsRef(el);
                observacaoInputRef.current = el;
              }}
              onKeyDown={(e) => handleAdvanceOnEnter(e, horarioInputRef)}
              isInvalid={Boolean(errors.observacao)}
              maxLength={250}
              placeholder="Observações"
              style={{ ...s.compact, resize: 'none', flex: 1 }}
            />
            <span style={{ ...s.rightTag, minWidth: 68 }}>Atividade:</span>
            <Form.Control
              size="sm"
              {...register('atividade')}
              disabled={!agendaContext}
              maxLength={15}
              isInvalid={Boolean(errors.atividade)}
              style={{ ...s.ativField, width: 120, textTransform: 'uppercase' }}
              onKeyDown={handleAtividadeKeyDown}
            />
          </div>
          {errors.observacao && (
            <div className="invalid-feedback d-block">{errors.observacao.message}</div>
          )}
          {errors.atividade && (
            <div className="invalid-feedback d-block">{errors.atividade.message}</div>
          )}
        </Col>
      </Row>

      {/* Linha 2 — Convênio + Data + Hora + Status */}
      <Row className="gx-2 gy-1 align-items-center mb-1">
        <Col xs={12} md={5}>
          <div style={s.inlineField}>
            <span style={s.inlineLabel}>Convênio:</span>
            <Form.Control
              size="sm"
              disabled={!agendaContext}
              value={convenioCodigo || ''}
              onChange={handleChangeCodConvenio}
              onKeyDown={(e) => handleAdvanceOnEnter(e, procedimentoInputRef)}
              ref={convenioInputRef}
              style={{ ...s.codeField, ...s.codeCompact }}
            />
            <Form.Control
              as="select"
              size="sm"
              {...register('convenio')}
              isInvalid={Boolean(errors.convenio)}
              disabled={isLoadingConvenios || !agendaContext}
              style={{ ...s.compact, flex: 1 }}
            >
              <option value="">Selecione o convênio</option>
              {convenios.map((c) => (
                <option key={c.CODCONV} value={c.CODCONV}>
                  {c.SIGLACONV}
                </option>
              ))}
            </Form.Control>
          </div>
          {errors.convenio && (
            <div className="invalid-feedback d-block">{errors.convenio.message}</div>
          )}
        </Col>
        <Col xs={12} md={7}>
          <div style={s.rightGroup}>
            <span style={s.rightTag}>Data:</span>
            <Form.Control
              size="sm"
              disabled
              value={selectedDataAgenda}
              style={{ ...s.statusField, width: 110, flex: '0 0 110px' }}
            />
            <span style={{ ...s.rightTag, minWidth: 48 }}>Hora:</span>
            <Form.Control
              size="sm"
              disabled={!agendaContext}
              value={horarioInt || ''}
              onChange={handleChangeHorario}
              onKeyDown={handleHorarioKeyDown}
              ref={horarioInputRef}
              isInvalid={Boolean(errors.horario)}
              style={{ ...s.codeField, width: 74, flex: '0 0 74px' }}
              inputMode="numeric"
              placeholder="HHMM"
            />
            <Form.Control
              size="sm"
              {...register('ecg')}
              disabled={!agendaContext}
              maxLength={20}
              isInvalid={Boolean(errors.ecg)}
              style={{ ...s.codeField, width: 25, flex: '0 0 0px' }}
              onKeyDown={handleAtividadeKeyDown}
            />
            <span style={{ ...s.rightTag, minWidth: 48 }}>Status:</span>
            <Form.Control
              size="sm"
              disabled
              value={situacaoAgenda}
              style={{ ...s.statusField, width: 96, flex: '0 0 96px' }}
            />
            <Form.Control
              size="sm"
              disabled
              value={evolucao}
              style={{ ...s.statusField, flex: '0 0 150px' }}
            />
          </div>
          {errors.horario && (
            <div className="invalid-feedback d-block">{errors.horario.message}</div>
          )}
          {errors.ecg && <div className="invalid-feedback d-block">{errors.ecg.message}</div>}
        </Col>
      </Row>

      {/* Linha 3 — Procedimento + labels audit */}
      <Row className="gx-2 gy-1 align-items-center mb-1">
        <Col xs={12} md={5}>
          <div style={s.inlineField}>
            <span style={s.inlineLabel}>Proced:</span>
            <Form.Control
              size="sm"
              disabled={!agendaContext}
              value={procedimentoCodigo || ''}
              onChange={handleChangeCodProcedimento}
              onKeyDown={(e) => handleAdvanceOnEnter(e, observacaoInputRef)}
              ref={procedimentoInputRef}
              style={{ ...s.codeField, ...s.codeCompact }}
            />
            <Form.Control
              as="select"
              size="sm"
              {...register('procedimento')}
              isInvalid={Boolean(errors.procedimento)}
              disabled={isLoadingProcedimentos || !agendaContext}
              style={{ ...s.compact, flex: 1 }}
            >
              <option value="">Selecione o procedimento</option>
              {procedimentos.map((p) => (
                <option key={p.CODPROCEDI} value={p.CODPROCEDI}>
                  {p.DESCPROCEDI}
                </option>
              ))}
            </Form.Control>
          </div>
          {errors.procedimento && (
            <div className="invalid-feedback d-block">{errors.procedimento.message}</div>
          )}
        </Col>
        <Col xs={12} md={7}>
          <div style={{ ...s.rightGroup, fontSize: '0.78rem', color: '#1d4ed8' }}>
            {AUDIT_COLUMNS.map(({ label }) => (
              <span key={label} style={{ flex: 1, textAlign: 'center' }}>
                {label}
              </span>
            ))}
          </div>
        </Col>
      </Row>

      {/* Linha 4 — Médico + valores audit */}
      <Row className="gx-2 gy-1 align-items-center">
        <Col xs={12} md={5}>
          <div style={s.inlineField}>
            <span style={s.inlineLabel}>Médico:</span>
            <Form.Control
              size="sm"
              disabled
              value={codMedInput}
              style={{ ...s.medField, ...s.codeCompact }}
            />
            <Form.Control
              size="sm"
              disabled
              value={medicoNome}
              placeholder="Médico"
              style={{ ...s.compact, flex: 1 }}
            />
          </div>
        </Col>
        <Col xs={12} md={7}>
          <div style={s.rightGroup}>
            {AUDIT_COLUMNS.map(({ field, style }) => (
              <Form.Control
                key={field}
                size="sm"
                disabled
                value={audit[field]}
                style={style || s.auditField}
              />
            ))}
          </div>
        </Col>
      </Row>
      {apiError && (
        <Row className="m-2">
          <Col>
            <Alert
              variant={alertaOk ? 'success' : 'danger'}
              dismissible
              onClose={() => setApiError(null)}
              className="mb-0 shadow-sm fs-7"
            >
              <div className="fw-bold mb-1">{alertaOk ? 'AVISO:' : 'ERRO:'}</div>
              <div>{alertaTexto}</div>
            </Alert>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default FormAgendaFields;
